export const SNOW_PLOW_ANALYTICS_EVENT_CATEGORIES = {
  DBO_NOTIFICATIONS: "dboNotifications",
} as const;

export const SNOW_PLOW_ANALYTIC_EVENTS = {
  OPEN_NOTIFICATIONS: "notificationsOpen",
} as const;
